import NavigationBar from "../NavigationBar/NavigationBarComponent";
import { Col, Row, Form } from "react-bootstrap";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoader } from "../../context/LoaderContext";
import { getTemplateData } from "../../api/commonApi";
import { CreateEmailMapping, GetEmailTemplateFields, GetEmailTemplateGroup, GetEmailTemplateMappingbyId, GetFieldData } from "../../api/emailTemplateMappingApi/emailTemplateMappingApi";
import { useSnackbar } from "../Common/SnackbarContext";
import LocalStorageUtil from "../../utils/localStorage";

interface Option {
    value: number;
    label: string;
}

interface Category {
    label: string;
    options: Option[];
}

const EmailTemplateMappingAction = (props: any) => {
    const location = useLocation();
    const { showSnackbar } = useSnackbar();
    const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
    const [isDisabledTemplateGroup, setIsDisabledTemplateGroup] = useState<boolean>(true);
    const [isDisabledField, setIsDisabledField] = useState<boolean>(true);
    const action = location.state?.action || {};
    const rowData = location.state?.rowData || {};
    const [data, setData] = useState<any>([]);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [emailTemplateMappingId, setEmailTemplateMappingId] = useState<number>(0);
    const navigate = useNavigate();
    const handelCancel = () => {
        setConfirmDialogOpen(true);
    };
    const [formData, setFormData] = useState<{
        templateNameId?: number | "";
        templateGroupId?: number | "";
        fieldId?: number | "";
        value?: string;
    }>({});
    type errorModel = {
        templateNameError?: string;
        templateGroupError?: string;
        fieldError?: string;
    };
    const [errors, setErrors] = useState<errorModel>({});
    //Close the dialog box after confirmation
    const handleConfirmDialogClose = (confirm: boolean) => {
        setConfirmDialogOpen(false);
        if (confirm) {
            // Add your logic here if needed
            navigate("/emailtemplatemapping"); // Redirect to FileLocation
        } else {
            setConfirmDialogOpen(false);
        }
    };

    const setValidation = () => {
        let error: errorModel = {};
        if (formData.fieldId === undefined || formData.fieldId === 0) {
            error.fieldError = "Please select the Field Name";
        }

        if (formData.templateGroupId === undefined || formData.templateGroupId === 0) {
            error.templateGroupError = "Please select the Group Name";
        }

        if (formData.templateNameId === undefined || formData.templateNameId === 0) {
            error.templateNameError = "Please select the template name";
        }

        if (error.fieldError !== "" || error.templateGroupError !== "" || error.templateNameError !== "") {
            setErrors(error);
        } else {
            // Proceed with form submission or other logic
            setErrors({});
            addEmailTemplateMapping();
        }
    }

    const addEmailTemplateMapping = async () => {
        const payload: any = {
            contextName: LocalStorageUtil.getItem("contextName")?.toString() ?? "",
            emailTemplateGroupId: formData.templateGroupId,
            emailTemplateTypeId: formData.templateNameId,
            metadataFieldId: formData.fieldId,
            value: formData.value,
            emailTemplateMappingId: rowData.emailTemplateMappingId === 0 ? emailTemplateMappingId : rowData.emailTemplateMappingId,
        }

        const response = await CreateEmailMapping(payload);

        if (response) {
            navigate("/emailtemplatemapping");
            if (action === "Edit") {
                showSnackbar("Email Template Updated Successfully");
            } else {
                showSnackbar("Email Template Created Successfully");
            }
        }
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setErrors({});
        setValidation();
    };

    useEffect(() => {
        getTemplate();
        getField();
        if (action === "Edit") {
            getTemplateGroup(rowData.emailTemplateTypeId);
            getTemplateDataById();            
            setIsEdit(true);
        }
        setFormData({
            templateNameId: 0,
            templateGroupId: 0,
            fieldId: 0,
            value: "",
        })
    }, []);

    const getTemplateDataById = async () => {
        const payload: any = {
            contextName: LocalStorageUtil.getItem("contextName")?.toString() ?? "",
            EmailTemplateMappingId: rowData.emailTemplateMappingId,
        }
        const data = await GetEmailTemplateMappingbyId(payload);
        setData(data);
    }

    useEffect(() => {
        if (data && data.length > 0) {
            setFormData({
                fieldId: data[0]?.metadataFieldId ?? 0,
                templateNameId: data[0]?.emailTemplateTypeId ?? 0,
                templateGroupId: data[0]?.emailTemplateGroupId ?? 0,
                value: data[0]?.value ?? "",
            });
            setIsDisabledField(false);
        }
    }, [data, rowData]);

    const { setLoading } = useLoader();
    const [template, setTemplate] = useState<any>([]);
    const [templateGroup, setTemplateGroup] = useState<any>([]);
    const [field, setField] = useState<any>([]);

    const getField = async () => {
        setLoading(true);
        const params: any = {
            accountId: LocalStorageUtil.getItem("accountId") ?? "",
            contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
        }
        try {
            const response = await GetFieldData(params);
            const transformedData = transformData(response);
            setField(transformedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const transformData = (data: any[]): Category[] => {
        const categoryMap: { [key: string]: Category } = {};

        data.forEach(item => {
            const { categoryName, fieldMappingId, field } = item;

            if (!categoryMap[categoryName]) {
                categoryMap[categoryName] = {
                    label: categoryName,
                    options: []
                };
            }

            categoryMap[categoryName].options.push({ value: fieldMappingId, label: field });
        });
        return Object.values(categoryMap);
    };

    const getTemplate = async () => {
        setLoading(true);
        const payload: any = {
            contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
            businessUnitId: Number(LocalStorageUtil.getItem("businessUnitId") ?? 0),
            templateType: "0"
        };
        try {
            const data = await getTemplateData(payload);
            setTemplate(data);
        } catch (error) {
            showSnackbar("Error fetching data", true);
        } finally {
            setLoading(false);
        }
    }

    const getTemplateGroup = async (templateId: number) => {
        setLoading(true);
        const payload: any = {
            contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
            templateTypeId: templateId
        };
        try {
            const data = await GetEmailTemplateGroup(payload);
            setIsDisabledTemplateGroup(false);
            setTemplateGroup(data);            
        } catch (error) {
            showSnackbar("Error fetching data", true);
        } finally {
            setLoading(false);
        }
    }

    const handleTemplateChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setFormData((prevState) => ({
            ...prevState,
            templateNameId: Number(event.target.value),
            templateGroupId: 0,
            fieldId: 0,
            value: ""
        }));
        setIsEdit(false);
        getTemplateGroup(Number(event.target.value));
    };

    const handleTemplateGroupChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setFormData((prevState) => ({
            ...prevState,
            templateGroupId: Number(event.target.value),
        }));
        GetEmailTemplateField(Number(event.target.value));
        setIsDisabledField(false);
    };

    const handleFieldChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setFormData((prevState) => ({
            ...prevState,
            fieldId: Number(event.target.value),
        }));
    }

    const handleValueChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setFormData((prevState) => ({
            ...prevState,
            value: event.target.value,
        }));
    };

    const GetEmailTemplateField = async (templateGroupId: number) => {
        setLoading(true);
        const payload: any = {
            contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
            emailTemplateGroupId: templateGroupId
        };
        try {
            const data = await GetEmailTemplateFields(payload);
            if (data.metadataFieldId !== null && data.value !== "") {
                setIsEdit(true);
                setIsDisabledTemplateGroup(true);
            }
            setEmailTemplateMappingId(data.emailTemplateMappingId);
            setIsDisabledField(false);
            setFormData((prevState) => ({
                ...prevState,
                fieldId: data.metadataFieldId,
                value: data.value
            }));

        } catch (error) {
            showSnackbar("Error fetching data", true);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            {action === "Edit" && isEdit ?(
                <NavigationBar menuTitle="Configuration" title="Email Template Mapping" text="Email Template Mapping - Edit" />
            ) : (
                <NavigationBar menuTitle="Configuration" title="Email Template Mapping" text="Email Template Mapping - Create New" />
            )}
            
            <div className="ag-theme-quartz-dark" style={{ margin: "4vh" }}>
                <Form>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="formCustomer">
                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)" , fontSize: "11px" }}>
                                    Template Name<span style={{ color: "var(--aggrid-text-color)" }} className="required">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="customerId"
                                    value={formData.templateNameId}
                                    required
                                    isInvalid={!!errors.templateNameError}
                                    onChange={handleTemplateChange}
                                    className="select-dropdown" style={{ fontSize: "11px" }}
                                >
                                    <option value="">Select</option>
                                    {template.map((template: any) => (
                                        <option key={template.templateTypeName} value={template.templateTypeId}>
                                            {template.templateTypeName}
                                        </option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {errors.templateNameError}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="formCustomer">
                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}>
                                    Template Group<span style={{ color: "var(--aggrid-text-color)" }} className="required">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="templateGroupId"
                                    value={formData.templateGroupId}
                                    disabled={isDisabledTemplateGroup}
                                    required
                                    isInvalid={!!errors.templateGroupError}
                                    onChange={handleTemplateGroupChange}
                                    className="select-dropdown" style={{ fontSize: "11px" }}
                                >
                                    <option value="">Select</option>
                                    {templateGroup.map((templateGrp: any) => (
                                        <option key={templateGrp.emailTemplateGroupId} value={templateGrp.emailTemplateGroupId}>
                                            {templateGrp.emailTemplateGroupName}
                                        </option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {errors.templateGroupError}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="formCustomer">
                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)" , fontSize:"11px"}}>
                                    Field<span style={{ color: "var(--aggrid-text-color)" }} className="required">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="fieldId"
                                    value={formData.fieldId}
                                    disabled={isDisabledField}
                                    required
                                    isInvalid={!!errors.fieldError}
                                    onChange={handleFieldChange}
                                    className="select-dropdown" style={{ fontSize: "11px" }}
                                >
                                    <option value="">Select</option>
                                    {field.map((field: any) => (
                                        <optgroup key={field.label} label={field.label}>
                                            {field.options.map((option: any) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </optgroup>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {errors.fieldError}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="formCustomer">
                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)", fontSize: "11px" }}>
                                    Value
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="value"
                                    value={formData.value}
                                    onChange={handleValueChange}
                                    className="input-box" style={{ fontSize: "11px" }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div
                        style={{
                            width: "95%",
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "16px",
                            marginBottom: "15px"
                        }}
                    >
                        {action === "Edit" && isEdit ? (
                            <Button variant="contained" onClick={handleSubmit} className="update-button">
                                Update
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                type="submit"
                                className="update-button"
                                onClick={handleSubmit}
                            >
                                Create
                            </Button>
                        )}
                        <Button className="cancel-button"
                            onClick={handelCancel}>
                            Cancel
                        </Button>
                    </div>
                </Form>
                <Dialog
                    open={confirmDialogOpen}
                    onClose={() => handleConfirmDialogClose(false)}
                    fullWidth
                    maxWidth="xs"
                >
                    <DialogTitle
                        style={{
                            backgroundColor: "var(--primary-color)",
                            color: "var(--aggrid-text-color)",
                            fontSize: "14px",
                        }}
                    >
                        Email Template Mapping - { action === "Edit" ? "Save" : "Create New"}
                    </DialogTitle>
                    <DialogContent style={{ fontSize: "14px", marginTop: "20px" }}>
                        Are you sure you want to Cancel?
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => handleConfirmDialogClose(true)}
                            color="primary"
                            style={{
                                fontSize: "14px",
                                color: "var(--aggrid-text-color)",
                                backgroundColor: "var(--primary-color)",
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            onClick={() => handleConfirmDialogClose(false)}
                            color="primary"
                            style={{
                                fontSize: "14px",
                                color: "var(--aggrid-text-color)",
                                backgroundColor: "var(--primary-color)",
                            }}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}

export default EmailTemplateMappingAction;